import React, { useState } from 'react';
import { Card, Accordion, Form } from "react-bootstrap"
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import Masonry from 'react-masonry-css';
import momenttz from '../../helpers/momenttz'
import ReactPaginate from 'react-paginate'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import CustomButton from '../../CustomButton';
import { videoPlayerIcons, eventIcons } from '../../helpers/iconHelpers';
import { eventTypeDetection, getAccessibleSnapshotChannel } from '../../helpers/helperEvents';
import { formatWithZoneAbbrNode } from '../../helpers/timeDisplaySettings';

const EventClipsGrid = (props) => {
	const { t, i18n } = useTranslation('translation', { keyPrefix: 'eventsPage.eventClipsContainer.eventClipsGrid' });
	const user = useSelector(state => state.user.user)
	const { sizePerPage, handlePageChange, totalSize, events, actionsFormatter, location, editVehicleUser, editVehicle, openEventSnapshot, openEventVideoAll, cardActionsFormatter, showDate, openEventNote } = props;

	const formatEventColor = (type) => {
		switch (type) {
			case 'G-Sensor (legacy)':
				return { 'backgroundColor': '#888', 'color': '#fff' }
			case 'High G-Force':
				return { 'backgroundColor': '#000', 'color': '#fff' }
			case 'Speed':
				return { 'backgroundColor': '#9AE78D' }
			default:
				return { 'backgroundColor': '#fff' }
		}
	}

	const formatTimestamp = (timestamp, deviceTz) => {
		if (timestamp) {
			return showDate ?
				formatWithZoneAbbrNode(momenttz(`${timestamp}+00`, deviceTz), 'M/DD/YY h:mm A') :
				formatWithZoneAbbrNode(momenttz(`${timestamp}+00`, deviceTz), 'h:mm A');
		}
	}

	const formatCardText = (event) => {
		const type = eventTypeDetection(event)

		if (type.includes(',')) {
			const typeArr = type.split(',');

			return (
				<>
					<div className="event-info-row-container">
						<span className="event-time">{formatTimestamp(event.timestamp, event.device_tz)}</span>
						<div className="vehicle-name-container">
							{editVehicleUser ?
								<span className="vehicle-name"
									onClick={() => editVehicle(event.device_id)}>{event.vehicle_name || event.device_id}</span> :
								<span className="vehicle-name">{event.vehicle_name || event.device_id}</span>
							}
						</div>
					</div>
					<div className="event-type-row-container">
						{event.has_feedback && <label style={{ width: "1rem", height: "1rem" }}>{eventIcons.eventFeedbackIcon}</label>}
						<div
							className="event-type"
							style={formatEventColor(typeArr[1])}>{i18n.t(`constants.eventNames.${typeArr[1].replace(/\s/g, "_")}`, typeArr[1])}
						</div>
						<div
							className="event-type"
							style={formatEventColor(typeArr[0])}>{i18n.t(`constants.eventNames.${typeArr[0].replace(/\s/g, "_")}`, typeArr[0])}
						</div>
					</div>
				</>
			)
		}

		return (
			<>
				<div className="event-info-row-container">
					<span className="event-time">{formatTimestamp(event.timestamp, event.device_tz)}</span>
					<div className="vehicle-name-container">
						{editVehicleUser ?
							<span className="vehicle-name clickable"
								onClick={() => editVehicle(event.device_id)}>{event.vehicle_name || event.device_id}</span> :
							<span className="vehicle-name">{event.vehicle_name || event.device_id}</span>
						}
					</div>
				</div>
				<div className="event-type-row-container">
					{event.has_feedback && <label style={{ width: "1rem", height: "1rem" }}>{eventIcons.eventFeedbackIcon}</label>}
					<div
						className="event-type"
						style={formatEventColor(type)}>{i18n.t(`constants.eventNames.${type.replace(/\s/g, "_")}`, type)}
					</div>
				</div>
			</>
		)
	}

	const showVideo = (event) => {
		if (!['VIDEO_UPLOADED', 'PARTIAL_VIDEO'].includes(event?.uploading_status)) {
			openEventSnapshot(event);
		} else {
			openEventVideoAll(event, 'Grid');
		}
	}

	const getImageSnapshot = (event) => {
		const firstEventType = event.type.split(',')[0]
		const showPlayButton = ['VIDEO_UPLOADED', 'PARTIAL_VIDEO'].includes(event?.uploading_status)
		let current_snapshot = ''

		if ((['External Driver', 'Driver', 'Drowsiness', 'Distraction', 'Phone Use', 'Phone Use/Hand to Head', 'Yawning', 'Drowsiness/Head Down', 'Seatbelt', 'Smoking', 'CameraBlock'].includes(firstEventType) || event.event_type.includes('DmsWarning')) && getAccessibleSnapshotChannel(event, user, [2])) {
			current_snapshot = 2
		}
		else {
			current_snapshot = getAccessibleSnapshotChannel(event, user) || ''
		}

		if (['archived', 'restoring'].includes(event.archive)) {
			return (
				<div className='image-error video-error'>
					<span
						className='video-error-message'>{event.archive === 'archived' ? t('eventArchived') : t('inRestoringProcess')}</span>
				</div>
			)
		}
		else if (!['VIDEO_UPLOADED', 'PARTIAL_VIDEO'].includes(event.uploading_status) && event.snapshot_status === 'SNAPSHOT_UPLOADED' && current_snapshot) {
			// return <img src={event.snapshot_1 || event.snapshot_2} className='card-snapshot' onClick={() => showVideo(event)} />
			return <img src={event[`snapshot_${current_snapshot}`]} className='card-snapshot' onClick={() => showVideo(event)} />
		}
		else if (event.uploading_status === 'EVENT_REPORTED' && event.snapshot_status === 'SNAPSHOT_REQUESTED') {
			return (
				<div className='image-error video-error'>
					<span className='video-error-message'>{t('customVideoRequested')}</span>
				</div>
			)
		}
		else if (event.uploading_status === 'VIDEO_NON_EXIST' && event.clip_retry && [1, 2].includes(event.clip_retry)) {
			return (
				<div className='image-error video-error'>
					<span className='video-error-message'>{t('pending')}</span>
				</div>
			)
		}
		else if (event.uploading_status === 'VIDEO_NON_EXIST' && event.type === 'Custom Clip') {
			return <div className='image-error video-error'>
				<span className='video-error-message'>{t('noVideoFound')}</span>
			</div>
		}
		else if (!['VIDEO_UPLOADED', 'PARTIAL_VIDEO'].includes(event.uploading_status)) {
			return <div className='image-error video-error'>
				<span className='video-error-message'>{t('noVideoAvailable')}</span>
			</div>
		}
		else if (!current_snapshot) {
			return <div className='image-error card-snapshot' onClick={() => showVideo(event)}>
				<CustomButton size="icon" variant="empty" prefix='play-button'>{videoPlayerIcons.playIcon}</CustomButton>
			</div>
		}

		return (
			<div onClick={() => showVideo(event)}>
				<img src={event[`snapshot_${current_snapshot}`]} className='card-snapshot' />
				{showPlayButton &&
					<CustomButton size="icon" variant="empty" prefix='play-button'>
						{videoPlayerIcons.playIcon}
					</CustomButton>
				}
			</div>
		)
	}

	const EventCard = ({ event, location }) => {
		const [open, setOpen] = useState(false);

		return (
			<Card className="square-card">
				<Card.Body className={`card-content ${(!clickable(event) || !event.snapshot_1) ? 'no-image' : ''}`}>
					{event && getImageSnapshot(event)}
				</Card.Body>
				<Card.Footer
					className={`card-text ${((location && location.event_id === event.id) ? 'active' : '')}`}
				>
					{formatCardText(event)}
					<div className="actions-icons-container">
						{cardActionsFormatter(event)}
					</div>
					<div className="collapse-icon-container">
						{
							open ? (
								<FaChevronUp className="icon-up" onClick={() => setOpen(!open)} />
							) : (
								<FaChevronDown className="icon-down" onClick={() => setOpen(!open)} />
							)
						}
					</div>
				</Card.Footer>
				<Accordion.Collapse className="collapsed-panel" in={open} eventKey={event.id}>
					<>
						<div className="info-panel">
							<span>
								<strong>{t('driver')}:</strong>&nbsp;{event.driver_name || ''}
							</span>
							<span>
								<strong>{t('duration')}:</strong>&nbsp;{event.duration || ''}
							</span>
							<span>
								<strong>{t('eventId')}:</strong>&nbsp;{event.id || ''}
							</span>
							<span>
								<strong>{t('group')}:</strong>&nbsp;{event?.groups?.length ? event.groups[0] : ''}
							</span>
							<span>
								<strong>{t('label')}:</strong>&nbsp;{event.event_label || ''}
							</span>
						</div>
						<div className="centered-container">
							<span className='notes'>{t('notes')}</span>
						</div>
						<div className="info-panel">
							<span>
								<strong>{t('createdBy')}:</strong>&nbsp;{event?.last_reviewed_name || ''}
							</span>
							<span>
								<strong>{t('lastUpdated')}:</strong>&nbsp;
								{event?.last_reviewed ? formatWithZoneAbbrNode(momenttz(`${event.last_reviewed}+00`, event?.device_tz), 'M/DD/YYYY hh:mm:ss A') : ''}
							</span>
							<span>
								<strong>{t('markedAsreviewed')}?</strong>&nbsp;
								{event?.has_review ? t('yes') : t('no')}
							</span>
						</div>
						<div className="centered-container">
							<CustomButton
								size="xs"
								variant="link"
								onClick={() => openEventNote(event)}
							>
								{t('edit')}
							</CustomButton>
						</div>
						<div className="info-panel">
							<Form.Control
								readOnly
								disabled
								className="notes-textarea"
								as="textarea"
								name="content"
								value={event?.event_notes || event?.custom_event_type || ''}
								rows={3}
							/>
						</div>
					</>
				</Accordion.Collapse>
			</Card>
		);
	};

	if (!events.length) {
		return <div className='no-events-message'>
			{t('noEventsRecorded')}
		</div>
	}

	const onPageChange = (pageNumber) => {
		handlePageChange(pageNumber.selected + 1, sizePerPage)
	}

	const clickable = (event) => (event.uploading_status === 'VIDEO_UPLOADED' || event.uploading_status === 'PARTIAL_VIDEO' || event.snapshot_status === 'SNAPSHOT_UPLOADED')

	return (
		<>
			<Masonry
				breakpointCols={{
					default: 4,
					1200: 3,
					992: 2,
					766: 1
				}}
				className="event-grid"
				columnClassName="event_grid_column">
				{events.map(event =>
					<EventCard key={event.id} event={event} location={location} />
				)}
			</Masonry>
			{/*<div className='event-grid'>*/}
			{/*	{events.map(event =>*/}
			{/*		<EventCard key={event.id} event={event} location={location}/>*/}
			{/*	)}*/}
			{/*</div>*/}
			{totalSize > sizePerPage &&
				<ReactPaginate pageCount={(Math.floor((totalSize - 1) / sizePerPage) + 1)} pageRangeDisplayed={3}
					marginPagesDisplayed={3} containerClassName='grid-pagination'
					activeClassName='active-pagination' disabledClassName='disabled-pagination'
					onPageChange={onPageChange} forcePage={props.page - 1} />
			}
		</>
	)
}

export default EventClipsGrid;
